$(document).ready(function () {

    if ($('#roles_table').length) {

        let url = window.location.origin + '/privilege/manager/roles/get';

        setTimeout(function () {
            roles_table();
        }, 500);

        function roles_table() {

            $('#roles_table').dataTable({
                "processing": true,
                "serverSide": true,
                "ajax": url,
                "columns": [
                    {data: 'name'},
                    {data: 'guard_name'},
                    {data: 'created_at'},
                ],
                "order": [[2, 'asc']],
                "columnDefs": [
                    {
                        "targets": 3,
                        "render": function (data, type, row, meta) {
                            if (row.id != 1) {
                                return "<button type='button' class='btn btn-primary btn-sm edit-rol' data-roles='" + row + "' data-toggle='tooltip' title='Editar Rol'><i class='fas fa-pencil-alt'></i></button> "
                                    + "<button type='button' class='btn btn-danger btn-sm remove-rol' data-roles='" + row + "' data-toggle='tooltip' title='Eliminar Rol'><i class='fas fa-trash'></i></button> ";
                            }
                            return "No Aplica";
                        }
                    }],
                "language": {
                    "url": window.location.origin + "/json/Spanish.json"
                },
            });

            $('#roles_table tbody').on('click', '.edit-rol', function (e) {
                e.preventDefault();
                let table = $("#roles_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                $.ajax({
                    url: window.location.origin + '/privilege/manager/roles/' + rowData.id + '/edit',
                    type: 'GET',
                })
                    .done(function (response) {
                        document.getElementById('div_modal_permissions').innerHTML = response;
                        $('#modal-permissions').modal("show");
                    })
                    .fail(function (jqXHR, textStatus) {
                        console.log(jqXHR);
                        alert("Disculpe, existió un problema");
                    });
            });

            $('#roles_table tbody').on('click', '.remove-rol', function (e) {
                e.preventDefault();
                let table = $("#roles_table").DataTable();
                let rowData = table.row($(this).parents('tr')).data();

                Swal
                    .fire({
                        title: "Eliminar el rol " + rowData.name,
                        text: "¿Eliminar?",
                        icon: 'warning',
                        showCancelButton: true,
                        confirmButtonText: "Sí, eliminar",
                        cancelButtonText: "Cancelar",
                    })
                    .then(resultado => {
                        if (resultado.value) {
                            //let url = ;
                            $.ajax({
                                url: window.location.origin + '/privilege/manager/roles/' + rowData.id,
                                type: 'DELETE',
                                headers: {
                                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                                }
                            })
                                .done(function (response) {
                                    Swal.fire('Eliminado', 'Se ha eliminado el rol.', 'success')
                                        .then(() => {
                                            $('#roles_table').DataTable().ajax.url(url).load();
                                        });
                                })
                                .fail(function (jqXHR, textStatus) {
                                    console.log(jqXHR);
                                    alert("Disculpe, existió un problema");
                                });
                        }
                    });
            });

        }

        document.getElementById('add_roles').onclick = function () {
            $.ajax({
                url: window.location.origin + '/privilege/manager/roles/create',
                type: 'GET',
            })
                .done(function (response) {
                    document.getElementById('div_modal_permissions').innerHTML = response;
                    $('#modal-permissions').modal("show");
                })
                .fail(function (jqXHR, textStatus) {
                    console.log(jqXHR);
                    alert("Disculpe, existió un problema");
                });
        }

        $(document).on('click', '#send_rol', function (event) {
            const data = $("#formRoles").serialize();
            event.preventDefault();
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/privilege/manager/roles',
                type: 'POST',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Agregado', ' Se agrego el rol correctamente', 'success')
                        .then(() => {
                            $('#modal-permissions').modal("hide");
                            $('#roles_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });

        $(document).on('click', '#sent_rol_update', function (event) {
            const data = $("#formRoles").serialize();
            let id = $("#id").val();
            event.preventDefault();
            document.getElementById('div_message').innerHTML = "";
            $.ajax({
                data: data,
                url: window.location.origin + '/privilege/manager/roles/' + id,
                type: 'PUT',
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            })
                .done(function (response) {
                    Swal.fire('Actualizado', 'Se actualizo el rol correctamente', 'success')
                        .then(() => {
                            $('#modal-permissions').modal("hide");
                            $('#roles_table').DataTable().ajax.url(url).load();
                        });
                })
                .fail(function (jqXHR, textStatus) {
                    //validacion de laravel a campos lo ignoramos unicamente por que entra en fail xk no pasa la validacion
                    if (jqXHR['status'] == 422) {

                        let errors = "<ul class=''>";
                        let items = "";

                        $.each(jqXHR['responseJSON']['errors'], function (index, value) {
                            items = items + "<li class='' style='text-align:left'>" + value + "</li>";
                        });

                        errors = errors + items + "</ul>";
                        let view = "<div class='row'><div class='card-body'><div class='alert alert-danger alert-dismissible'>"
                            + "<button type='button' class='close' data-dismiss='alert' aria-hidden='true'>×</button>"
                            + "<h5><i class='icon fas fa-ban'></i> Advertencia</h5>"
                            + errors
                            + "</div></div></div>";
                        document.getElementById('div_message').innerHTML = view;
                    } else {
                        console.log(jqXHR['status']);
                        alert("Disculpe, existió un problema");
                    }
                });
        });
    }

});
